"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var actions_1 = require("@shopify/app-bridge/actions");

var transformers_1 = require("../../utilities/transformers");

var context_1 = require("../../context");

var TitleBar =
/** @class */
function (_super) {
  __extends(TitleBar, _super);

  function TitleBar() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TitleBar.prototype.componentDidMount = function () {
    var app = this.context;
    this.titleBar = actions_1.TitleBar.create(app, this.transformProps());
  };

  TitleBar.prototype.componentDidUpdate = function () {
    this.titleBar.unsubscribe();
    this.titleBar.set(this.transformProps());
  };

  TitleBar.prototype.componentWillUnmount = function () {
    this.titleBar.unsubscribe();
  };

  TitleBar.prototype.render = function () {
    return null;
  };

  TitleBar.prototype.transformProps = function () {
    var app = this.context;
    var _a = this.props,
        title = _a.title,
        primaryAction = _a.primaryAction,
        secondaryActions = _a.secondaryActions,
        actionGroups = _a.actionGroups;
    return {
      title: title,
      buttons: transformers_1.transformActions(app, {
        primaryAction: primaryAction,
        secondaryActions: secondaryActions,
        actionGroups: actionGroups
      }),
      breadcrumbs: this.transformBreadcrumbs()
    };
  };

  TitleBar.prototype.transformBreadcrumbs = function () {
    var app = this.context;
    var breadcrumbs = this.props.breadcrumbs;

    if (breadcrumbs == null || breadcrumbs.length === 0) {
      return undefined;
    }

    var breadcrumb = breadcrumbs[breadcrumbs.length - 1];
    var url = breadcrumb.url,
        onAction = breadcrumb.onAction,
        target = breadcrumb.target,
        content = breadcrumb.content;
    var button = actions_1.Button.create(app, {
      label: content || ''
    });
    var redirect = transformers_1.generateRedirect(app, url, target);

    if (redirect != null) {
      button.subscribe(actions_1.Button.Action.CLICK, redirect);
    }

    if (onAction != null) {
      button.subscribe(actions_1.Button.Action.CLICK, onAction);
    }

    return button;
  };

  TitleBar.contextType = context_1.AppBridgeContext;
  return TitleBar;
}(react_1.default.PureComponent);

exports.default = TitleBar;